export interface User {
	id?: string;
	username?: string;
	accountName?: string;
	email?: string;
	firstName?: string;
	lastName?: string;
	createdTimestamp?: number;
	role: Roles;
	// Raw Azure AD security-group Object IDs from the `groups` token claim (GUIDs only —
	// Azure AD never puts a display name in the token itself; resolving them via Microsoft
	// Graph was tried and removed on 2026-09-08, see doc/migration/cognito-to-msal/TODO-NEXT.md
	// — AADSTS65001 consent_required on the current borrowed app registration).
	groupIds?: string[];
}

export enum Roles {
	BUSINESS_ADMIN = 'business_admin',
	ADMIN = 'admin',
	USER = 'user',
	TARIFF_CARD_ADMIN = 'tariff-card-admin'
}
